// Gjør søketeksten om til et forslag til ny kunde, når søket ikke ga treff:
// «Ola Nordmann 987 65 432» → fornavn Ola, etternavn Nordmann, telefon 98765432.
//
//   ord med @            → e-post
//   ord med bare sifre   → telefon (+47 og mellomrom fjernes; samles til ett nummer)
//   resten               → første ord er fornavn, resten etternavn
//
// Den ansatte ser og retter alt i skjemaet før kunden lagres.
export function forslagFraSok(sok) {
  const forslag = { firstName: '', lastName: '', phoneNumber: '', email: '' };
  const navn = [];
  let sifre = '';

  for (const ord of String(sok || '').trim().split(/\s+/).filter(Boolean)) {
    if (ord.includes('@')) {
      if (!forslag.email) forslag.email = ord.toLowerCase();
    } else if (/^\+?[\d().-]+$/.test(ord)) {
      sifre += ord.replace(/\D/g, '');
    } else {
      navn.push(ord);
    }
  }

  if (sifre.length === 10 && sifre.startsWith('47')) sifre = sifre.slice(2);
  forslag.phoneNumber = sifre;

  const stor = (s) => (s && s === s.toLowerCase() ? s.charAt(0).toUpperCase() + s.slice(1) : s);
  forslag.firstName = stor(navn[0] || '');
  forslag.lastName = navn.slice(1).map(stor).join(' ');
  return forslag;
}

// Kort tekst til knappen: «Ola Nordmann · 98765432».
export function forslagTekst(forslag) {
  return [[forslag.firstName, forslag.lastName].filter(Boolean).join(' '), forslag.phoneNumber, forslag.email]
    .filter(Boolean)
    .join(' · ');
}
